import { MerchantActionTypes } from './merchant.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addMerchantSuccess: null,
    addMerchantError: null,
    addMerchantReqStatus: '',
    merchantListSuccess: null,
    merchantListError: null,
    merchantDetailSuccess: null,
    merchantDetailError: null,
    updateMerchantDetailSuccess: null,
    updateMerchantDetailError: null,
    updateMerchantDetailReqStatus: '',
}

const merchantReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MerchantActionTypes.ADD_MERCHANT_REQUEST_SUCCESS:
            return {
                ...state,
                addMerchantSuccess: action.payload,
                addMerchantError: null,
                addMerchantReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case MerchantActionTypes.ADD_MERCHANT_REQUEST_ERROR:
            return {
                ...state,
                addMerchantSuccess: null,
                addMerchantError: action.payload,
                addMerchantReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case MerchantActionTypes.ADD_MERCHANT_REQUEST_STATUS:
            return {
                ...state,
                addMerchantReqStatus: ''
            }
        case MerchantActionTypes.MERCHANT_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                merchantListSuccess: action.payload,
                merchantListError: null
            }
        case MerchantActionTypes.MERCHANT_LIST_REQUEST_ERROR:
            return {
                ...state,
                merchantListSuccess: null,
                merchantListError: action.payload
            }
        case MerchantActionTypes.MERCHANT_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                merchantDetailSuccess: action.payload,
                merchantDetailError: null
            }
        case MerchantActionTypes.MERCHANT_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                merchantDetailSuccess: null,
                merchantDetailError: action.payload
            }
        case MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                updateMerchantDetailSuccess: action.payload,
                updateMerchantDetailError: null,
                updateMerchantDetailReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                updateMerchantDetailSuccess: null,
                updateMerchantDetailError: action.payload,
                updateMerchantDetailReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST_STATUS:
            return {
                ...state,
                updateMerchantDetailReqStatus: ''
            }
        case MerchantActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default merchantReducer